import React, { useContext, useEffect, useState } from 'react';
import { Grid, Icon, Box, LinearProgress } from '@mui/material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { useNavigate, useParams } from 'react-router-dom';
import { findOnArray, CustomPagination, summarizer } from 'utils/functions';
import { AuthContext } from 'contexts/AuthContext';
import { DropsContext } from 'contexts/DropsContext';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { RemessasContext } from 'contexts/RemessasContext';
import Container from 'components/Container';
import Header from 'components/Header';
import Button from 'components/Button';
import Card from 'components/Card';
import localeText from 'utils/localeText';
import moment from 'moment';

const Retorno = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [itens, setItens] = useState([]);
  const { user } = useContext(AuthContext);
  const { drops } = useContext(DropsContext);
  const { getRetorno, getLoading } = useContext(RemessasContext);
  const { postDocumento, postLoading } = useContext(DocumentosContext);

  const dadosdoc = itens?.find((f) => f?.documento_id == id);

  const getVinculos = (natureza_operacao_id) => {
    switch (natureza_operacao_id) {
      case 19:
        return 21;
      case 22:
        return 24;
      case 37:
        return 45;
      case 39:
        return 40;
      case 42:
        return 43;
      case 48:
        return 49;
      case 52:
        return 45;
      case 56:
        return 57;
      case 62:
        return 63;
      case 72:
        return 87;
      case 78:
        return 45;
      case 89:
        return 90;
      case 91:
        return 92;
      case 93:
        return 94;
      case 96:
        return 97;
      case 98:
        return 99;
      case 117:
        return 116;
      case 119:
        return 118;
      case 122:
        return 121;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (Boolean(id)) {
      const params = { id };
      const cb = (res) =>
        setItens(
          res?.map((r) => ({ ...r, _quantidade: r?.quantidade_retornar }))
        );
      getRetorno({ params, cb });
    }
  }, []);

  const onCellEditCommit = (e) => {
    const editedRows = itens?.map((c) => {
      if (c?.id === e?.id && e?.field === '_quantidade') {
        if (e?.value > c?.quantidade_retornar) {
          return { ...c, [e?.field]: c?.quantidade_retornar };
        } else {
          return { ...c, [e?.field]: e?.value };
        }
      } else {
        return { ...c };
      }
    });
    setItens(editedRows);
  };

  const onSubmit = () => {
    const especie_remessa = findOnArray(
      dadosdoc?.especie_id,
      drops?.EspecieDocumento
    );
    const especie_id = especie_remessa?.fiscal === 'SIM' ? 10 : 25;
    const especie = findOnArray(especie_id, drops?.EspecieDocumento);
    const natureza_operacao_id = getVinculos(dadosdoc?.natureza_operacao_id);
    const valor = summarizer(itens, 'precofin');
    const dt = moment().format('YYYY-MM-DD HH:mm:ss');

    let data = {
      Documento: {
        especie_id,
        natureza_operacao_id,
        users_id: user?.id,
        filial_id: user?.filial_id,
        cadastro_id: dadosdoc?.cadastro_id,
        dtemissao: dt,
      },
      Itens: itens?.map((i, index) => ({
        sequencia: index + 1,
        produto_id: i?.produto_id,
        descricao: i?.descricao,
        quantidade: i?._quantidade,
        referencia: i?.referencia,
        preco: i?.preco,
        precobase_id: i?.precobase_id,
        // cfo_id: i?.cfo_id,
        Vinculos: [{ documento_item_id_vinculo: i?.id }],
      })),
      Origens: [{ documento_id: id }],
      ...(valor > 0 && {
        Financeiros: [
          {
            forma_pagto_id: 1,
            parcela: 1,
            dtvenc: dt,
            valor,
          },
        ],
      }),
    };
    if (especie?.Grupo === 'SAIDA') {
      data = { ...data, Saida: { vendedor_id: user?.entidade_id } };
    }
    if (especie?.Grupo === 'ENTRADA') {
      data = {
        ...data,
        Entrada: { dtentrada: dt },
      };
    }

    postDocumento({ data, cb: () => navigate(-1) });
  };

  return (
    <Container>
      <Header titulo="Retorno de Remessa" />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ height: '75vh' }}>
              <DataGrid
                rows={itens}
                columns={[
                  {
                    field: 'referencia',
                    headerName: 'Referência',
                    width: 150,
                    sortable: false,
                  },
                  {
                    field: 'descricao',
                    headerName: 'Produto',
                    flex: 1,
                    minWidth: 400,
                    sortable: false,
                  },
                  {
                    field: 'quantidade',
                    headerName: 'Quantidade Total',
                    type: 'number',
                    width: 150,
                    sortable: false,
                  },
                  {
                    field: 'quantidade_retornada',
                    headerName: 'Quantidade Retornada',
                    type: 'number',
                    width: 200,
                    sortable: false,
                  },
                  {
                    field: 'quantidade_movimentada',
                    headerName: 'Quantidade Movimentada',
                    type: 'number',
                    width: 200,
                    sortable: false,
                  },
                  {
                    field: '_quantidade',
                    headerName: 'Quantidade a retornar',
                    type: 'number',
                    width: 200,
                    editable: dadosdoc?.natureza_operacao_id !== 37,
                    sortable: false,
                  },
                  {
                    field: 'actions',
                    headerName: 'Ações',
                    type: 'actions',
                    width: 100,
                    getActions: (params) => [
                      <GridActionsCellItem
                        icon={<Icon>delete</Icon>}
                        label="Excluir"
                        onClick={() =>
                          setItens(itens?.filter((r) => r?.id !== params?.id))
                        }
                      />,
                    ],
                  },
                ]}
                autoPageSize
                density="compact"
                disableSelectionOnClick
                disableColumnMenu
                showCellRightBorder
                showColumnRightBorder
                onCellEditCommit={onCellEditCommit}
                localeText={localeText}
                loading={getLoading}
                components={{
                  LoadingOverlay: LinearProgress,
                  Pagination: CustomPagination,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              loading={postLoading}
              onClick={onSubmit}
            >
              FINALIZAR
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Retorno;
